import { Table } from 'dexie';
import db, { Database } from '@/db';
import { PlayerForSaveDto } from '../../api/models';
import { ModuleName } from '@/constants';

export type TABLE_TYPE = Table<PlayerForSaveDto>;

export const TABLE = 'activePlayer';
const SCHEMA = ''; // no primary key since it only stores one record

export interface IActivePlayer extends PlayerForSaveDto {
  activeModule?: ModuleName;
}

interface IActivePlayerRepository {
  get(): Promise<IActivePlayer | undefined>;
  // eslint-disable-next-line no-unused-vars
  set(player: IActivePlayer): Promise<void>;
  clear(): Promise<void>;
}

class ActivePlayerDatabase implements IActivePlayerRepository {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  async get(): Promise<IActivePlayer | undefined> {
    return this.db[TABLE].get('current');
  }

  async set(player: IActivePlayer): Promise<void> {
    // Use put to overwrite or add new
    await this.db[TABLE].put(player, 'current');
  }

  async clear(): Promise<void> {
    await this.db[TABLE].delete('current');
  }
}

export const ActivePlayerDB = new ActivePlayerDatabase(db);
